import { defaultEvent, Event } from './Event';

export interface EventGuest {
    id: number;
    avatar?: string;
    first_name: string;
    last_name: string;
    job_description: string;
    function_event: string;
    event?: Event;
    event_id: number;
}

export const defaultEventGuest: EventGuest = {
    id: 0,
    first_name: '',
    last_name: '',
    job_description: '',
    function_event: '',
    event_id: 0
};

export interface EventGuestFilters {
    first_name?: string | null;
    last_name?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
